const HEART_PATH = 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';
const TOTAL = 18;
const CORES = ['#f43f5e', '#ec4899', '#fb7185', '#f9a8d4'];

export default function JukeboxDiaNamoradosBanner() {
  return (
    <div className="animate-fade-in overflow-hidden relative">
      <div className="bg-[linear-gradient(to_bottom,rgba(136,19,55,0.20)_0%,rgba(244,63,94,0.05)_60%,transparent_100%)] border-b border-rose-500/[0.15] pb-2">

        {/* Fileira de corações SVG — mesma estrutura do varal de bandeirinhas */}
        <div className="relative pt-0">
          <div className="absolute top-2.5 inset-x-0 h-px bg-[linear-gradient(to_right,transparent,rgba(244,63,94,0.35)_10%,rgba(244,63,94,0.35)_90%,transparent)]" />
          <svg
            width="100%"
            height="24"
            viewBox={`0 0 ${TOTAL * 18} 24`}
            preserveAspectRatio="none"
            aria-hidden
          >
            {Array.from({ length: TOTAL }, (_, i) => {
              const cor  = CORES[i % CORES.length];
              const cx   = i * 18 + 9; // centro do coração
              return (
                <g
                  key={i}
                  transform={`translate(${cx - 6}, 2) scale(0.5)`}
                  className="animate-junina-balanco"
                  style={{ transformOrigin: `${cx}px 2px`, animationDelay: `${i * 75}ms` }}
                >
                  <path d={HEART_PATH} fill={cor} opacity={0.88} />
                </g>
              );
            })}
          </svg>
        </div>

        <div className="flex items-center justify-center gap-2 pt-0.5">
          <p className="font-black uppercase text-center text-[10px] tracking-[0.22em] text-rose-300/90"
            style={{ textShadow: '0 0 10px rgba(244,63,94,0.4)' }}>
            Dia dos Namorados
          </p>
        </div>
      </div>
    </div>
  );
}
